export const JWT_TOKEN_STORAGE_KEY = "jwt_token";
export const USER_NAME='user_name'
export const initialState = {
  isUserAuthenticated: false,
  user: {
    status: "idle",
  },
};



